/**
 * CLevelAuditPage - Executive audit intelligence dashboard
 *
 * Surfaces the CLevelAuditDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides executive-level audit insights, compliance trends, and risk indicators.
 *
 * Route: /admin/audit-intelligence
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconReportAnalytics } from '@tabler/icons-react';

import { CLevelAuditDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function CLevelAuditPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="indigo">
            <IconReportAnalytics size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Audit Intelligence</Title>
            <Text size="sm" c="dimmed">
              Executive-level audit insights, compliance trends, and risk indicators
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <CLevelAuditDashboard
        timeRange={{
          start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // Last 30 days
          end: new Date()
        }}
      />
    </Container>
  );
}

export default CLevelAuditPage;
